import UAParser from 'ua-parser-js';

class OperatingSystemServiceClass {
  constructor() {
    this.parser = new UAParser();
  }

  isMac() {
    const { name: OSName } = this.parser.getOS();
    if (!OSName) {
      return false;
    }
    return OSName.toLowerCase().indexOf('mac') !== -1;
  }
}

export const OperatingSystemService = new OperatingSystemServiceClass();
